import * as util from './util.js'
import * as tools from './tools.js'
import * as check from './check.js'
const utils = {
  ...util,
  ...tools,
  ...check
}

export default utils